
import {
  getSalesOrdersList,
  delSalesOrders,
  whetherShipmentsSalesOrders
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import adjustPriorities from "./components/adjust-priorities.vue";
import addSalesOrder from "./components/add-sales-order.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    adjustPriorities,
    addSalesOrder
  }
})
export default class PiSalesOrder extends Vue {
  private time: object[] = [];
  private total = 0;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private loading = false;
  private tableList: object[] = [
    { projectName: i18n.t("productionOrder.projectName") }
  ];
  private tableColumns: object[] = [
    {
      title: i18n.t("productionOrder.index"),
      type: "index",
      minWidth: 70
    },
    {
      title: i18n.t("productionOrder.priority"),
      key: "priority",
      minWidth: 70
    },
    {
      title: i18n.t("productionOrder.contractBillNumber"),
      key: "contractBillNumber",
      slot: "contractBillNumber",
      minWidth: 130
    },
    {
      title: i18n.t("productionOrder.projectName"),
      key: "projectName",
      minWidth: 120
    },
    {
      title: i18n.t("salesOrder.sellerName"),
      key: "sellerName",
      minWidth: 120
    },
    {
      title: i18n.t("salesOrder.specificationModel"),
      key: "specificationModel",
      slot: "specificationModel",
      minWidth: 100
    },
    {
      title: i18n.t("salesOrder.month"),
      key: "month",
      slot: "month",
      minWidth: 100
    },
    {
      title: i18n.t("salesOrder.deliveryTime"),
      key: "deliveryTime",
      minWidth: 100
    },
    {
      title: i18n.t("productionOrder.createTime"),
      key: "createTime",
      minWidth: 140
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      minWidth: 180
    }
  ];

  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    // this.getTableList();
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSalesOrdersList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  // 调整优先级
  public adjustPrioritiesClick(item: objAny) {
    const adjustPriorities: objAny = this.$refs.adjustPriorities;
    adjustPriorities.open(item);
  }
  // 设备发货
  public devDeliverGoodsClick(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("salesOrder.shipConfirm") + "",
      onOk: async () => {
        const ret = await whetherShipmentsSalesOrders({
          projectNamePkId: item.projectNamePkId,
          ifDelivery: 1
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("deleteSuccess"));
          this.getTableList();
        }
      }
    });
  }

  public addClick() {
    const addSalesOrder: objAny = this.$refs.addSalesOrder;
    addSalesOrder.open({}, "add");
  }

  public updataClick(item: objAny) {
    const addSalesOrder: objAny = this.$refs.addSalesOrder;
    addSalesOrder.open(item, "updata");
  }
  public detailsClick(item: objAny) {
    const addSalesOrder: objAny = this.$refs.addSalesOrder;
    addSalesOrder.open(item, "details");
  }
  public delClick(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("productionOrder.delConfirm") + "",
      onOk: async () => {
        const ret = await delSalesOrders({
          projectNamePkId: [item.projectNamePkId]
        });
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("deleteSuccess"));
          this.getTableList();
        }
      }
    });
  }
  mounted() {
    const d: any = new Date();
    const end: number = Date.parse(d) / 1000;
    const start: number = end - 60 * 60 * 25 * 90;
    this.formInline.startTime = this.$common.userDate(
      start * 1000,
      "yyyy-MM-dd"
    );
    this.formInline.endTime = this.$common.userDate(end * 1000, "yyyy-MM-dd");
    this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getTableList();
  }
}
